module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei6.svg";